export default {

	getFields(Selector) {
		return {
			create_account_password : {required: true, userPassword: true},
			create_account_repeat_password :{required: true, equalTo: '#create_account_password'}
		}
	},
}export default {

	getFields(Selector) {
		return {
			create_account_password : {required: true, userPassword: true},
			create_account_repeat_password :{required: true, equalTo: '#create_account_password'}
		}
	},
}